var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.9873 344C145.895 344 187.975 301.915 187.975 250C187.975 198.085 145.895 156 93.9873 156C42.0796 156 0 198.085 0 250C0 301.915 42.0796 344 93.9873 344Z",
    fill: "#04ADAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8177 338.377C147.176 338.377 188 297.55 188 247.188C188 196.826 147.176 156 96.8177 156C46.4591 156 5.63544 196.826 5.63544 247.188C5.63544 297.55 46.4591 338.377 96.8177 338.377Z",
    fill: "url(#paint0_linear_147_11517)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67352 248.899C6.56199 297.978 46.2892 337.781 95.7135 338.377C145.861 338.986 187.035 298.976 187.975 248.899H5.67352Z",
    fill: "#04ADAA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8177 317.465C135.631 317.465 167.096 286.001 167.096 247.188C167.096 208.376 135.631 176.912 96.8177 176.912C58.0043 176.912 26.5398 208.376 26.5398 247.188C26.5398 286.001 58.0043 317.465 96.8177 317.465Z",
    fill: "url(#paint1_linear_147_11517)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.894 223.193C166.017 230.811 167.603 239.091 167.806 247.409C167.908 255.74 166.486 264.097 163.719 271.974C158.186 287.743 146.813 301.386 132.369 309.497C117.976 317.633 100.803 320.704 84.6584 317.594C76.6114 316.027 68.8056 313.15 61.7613 308.939C54.7424 304.716 48.4723 299.222 43.37 292.834C48.9673 298.769 55.3262 303.938 62.4594 307.657C69.491 311.531 77.1826 314.083 85.0265 315.327C88.9611 315.897 92.9212 316.169 96.8939 316.169L102.834 315.819C103.824 315.806 104.801 315.599 105.779 315.457L108.711 314.977C116.491 313.565 124.043 310.844 130.935 306.892C144.846 299.157 155.774 286.201 161.625 271.171C167.502 256.128 168.009 238.844 162.907 223.206L162.894 223.193Z",
    fill: "url(#paint2_linear_147_11517)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4264 272.337C28.1644 264.77 26.5017 256.478 26.1971 248.121C26.0067 239.751 27.3267 231.304 30.1064 223.361C32.8479 215.393 37.1253 207.995 42.4688 201.503C47.825 195.012 54.3996 189.596 61.647 185.45C76.1798 177.236 93.5176 174.204 109.777 177.404C117.887 178.985 125.718 181.978 132.737 186.305C136.24 188.482 139.553 190.931 142.599 193.704C145.671 196.437 148.463 199.456 150.964 202.708C139.705 190.84 124.817 183.118 109.218 180.747C105.309 180.203 101.374 179.944 97.4396 179.957L91.5503 180.332C90.5603 180.345 89.5957 180.553 88.6311 180.708L85.7245 181.188C78.0075 182.613 70.5317 185.308 63.7159 189.221L61.1901 190.737C60.3651 191.268 59.4639 191.695 58.7024 192.33C57.1285 193.509 55.5293 194.662 53.9554 195.867L49.5511 199.832C48.155 201.231 46.8603 202.747 45.4896 204.173C40.273 210.158 36.1606 217.103 33.1906 224.54C27.3267 239.44 26.5144 256.569 31.4137 272.311L31.4264 272.337Z",
    fill: "url(#paint3_linear_147_11517)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.86 252.073L124.614 247.188L121.86 242.304L134.349 238.883L139.731 218.386L125.033 203.369L104.954 208.863L101.603 221.625L96.8178 218.814L92.0327 221.625L88.6819 208.863L68.6025 203.369L53.9047 218.386L59.2863 238.883L71.7756 242.304L69.0214 247.188L71.7756 252.073L59.2863 255.494L53.9047 275.991L68.6025 291.008L88.6819 285.514L92.0327 272.765L96.8178 275.576L101.603 272.765L104.954 285.514L125.033 291.008L139.731 275.991L134.349 255.494L121.86 252.073ZM123.218 284.089L109.904 280.448L105.411 263.358L96.8178 268.424L88.225 263.358L83.7319 280.448L70.4175 284.089L60.6698 274.138L64.2363 260.547L74.9234 257.631L80.9903 255.973L76.0276 247.201L80.9903 238.43L64.249 233.843L60.6825 220.252L70.4302 210.301L83.7446 213.942L88.2377 231.032L96.8305 225.966L105.423 231.032L109.916 213.942L123.231 210.301L132.978 220.252L129.412 233.843L112.671 238.43L117.633 247.201L112.671 255.973L129.412 260.547L132.978 274.138L123.231 284.089H123.218Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8177 236.434L103.494 240.373L107.352 247.188L103.494 254.017L96.8177 257.955L90.1288 254.017L86.2703 247.188L90.1288 240.373L96.8177 236.434Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222 245.437V231.491H278V245.437H222ZM222 268.509V254.525H278V268.509H222Z",
    fill: "#04ADAA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M405.987 344C457.895 344 499.975 301.915 499.975 250C499.975 198.085 457.895 156 405.987 156C354.08 156 312 198.085 312 250C312 301.915 354.08 344 405.987 344Z",
    fill: "#FFD551"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.818 338.377C459.176 338.377 500 297.55 500 247.188C500 196.826 459.176 156 408.818 156C358.459 156 317.635 196.826 317.635 247.188C317.635 297.55 358.459 338.377 408.818 338.377Z",
    fill: "#FDBF34"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29,
    d: "M317.673 248.899C318.562 297.978 358.289 337.781 407.713 338.377C457.861 338.986 499.035 298.976 499.975 248.899H317.673Z",
    fill: "url(#paint4_linear_147_11517)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.818 317.465C447.631 317.465 479.096 286.001 479.096 247.188C479.096 208.376 447.631 176.912 408.818 176.912C370.004 176.912 338.54 208.376 338.54 247.188C338.54 286.001 370.004 317.465 408.818 317.465Z",
    fill: "url(#paint5_linear_147_11517)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.894 223.193C478.017 230.811 479.603 239.091 479.806 247.409C479.895 255.74 478.486 264.097 475.719 271.974C470.186 287.743 458.813 301.386 444.356 309.497C429.963 317.633 412.79 320.704 396.646 317.594C388.599 316.027 380.793 313.15 373.749 308.939C366.73 304.716 360.46 299.222 355.357 292.834C360.955 298.769 367.314 303.938 374.447 307.657C381.478 311.531 389.17 314.083 397.014 315.327C400.948 315.897 404.908 316.169 408.881 316.169L414.821 315.819C415.811 315.806 416.789 315.599 417.766 315.457L420.698 314.977C428.478 313.565 436.03 310.844 442.922 306.892C456.833 299.157 467.774 286.201 473.612 271.171C479.489 256.128 479.997 238.844 474.894 223.206V223.193Z",
    fill: "url(#paint6_linear_147_11517)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M343.426 272.337C340.164 264.77 338.502 256.478 338.197 248.121C337.994 239.751 339.327 231.304 342.106 223.361C344.848 215.393 349.125 207.995 354.469 201.503C359.825 195.012 366.4 189.596 373.647 185.45C388.18 177.236 405.518 174.204 421.777 177.404C429.887 178.985 437.718 181.978 444.737 186.305C448.24 188.482 451.553 190.931 454.599 193.704C457.671 196.437 460.463 199.456 462.963 202.708C451.705 190.84 436.817 183.118 421.218 180.747C417.309 180.203 413.374 179.944 409.44 179.957L403.55 180.332C402.56 180.345 401.596 180.553 400.631 180.708L397.725 181.188C390.008 182.613 382.532 185.308 375.716 189.221L373.19 190.737C372.365 191.268 371.464 191.695 370.702 192.33C369.128 193.509 367.529 194.662 365.955 195.867L361.551 199.832C360.155 201.231 358.86 202.747 357.49 204.173C352.273 210.158 348.161 217.103 345.191 224.54C339.327 239.44 338.514 256.569 343.414 272.311L343.426 272.337Z",
    fill: "url(#paint7_linear_147_11517)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M427.095 202.125C428.631 202.76 429.837 203.719 430.141 205.494C430.255 206.142 430.217 206.829 430.268 207.593C431.677 207.593 433.048 207.554 434.418 207.593C436.284 207.658 437.807 209.044 438.163 210.897C438.518 212.763 437.617 214.655 435.904 215.367C435.231 215.652 434.457 215.717 433.72 215.769C432.604 215.834 431.487 215.782 430.217 215.782C430.217 216.248 430.217 216.65 430.217 217.039C430.217 235.113 430.217 253.174 430.23 271.249C430.23 273.076 429.659 274.527 428.022 275.395C425.534 276.717 422.5 275.045 422.259 272.195C422.17 271.158 422.246 270.109 422.246 268.826C415.596 274.734 408.158 276.989 399.756 275.33C393.917 274.177 389.094 271.119 385.261 266.481C377.455 257.01 377.48 242.55 385.337 233.286C390.046 227.728 395.973 224.553 403.195 224.074C410.417 223.595 416.662 226.017 422.158 230.941V215.795C420.914 215.795 419.721 215.808 418.515 215.795C416.408 215.756 414.872 214.68 414.365 212.892C413.616 210.301 415.38 207.736 418.033 207.619C419.378 207.554 420.723 207.619 422.208 207.619C421.942 204.963 422.856 203.045 425.382 202.151H427.108L427.095 202.125ZM422.183 249.922C422.208 240.179 414.39 232.198 404.82 232.185C395.262 232.185 387.495 240.049 387.431 249.806C387.368 259.627 395.148 267.608 404.782 267.621C414.352 267.647 422.145 259.717 422.17 249.922H422.183Z",
    fill: "url(#paint8_linear_147_11517)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M404.756 292.251C397.725 292.251 390.68 292.251 383.649 292.251C381.351 292.251 379.765 290.878 379.447 288.675C379.13 286.512 380.679 284.361 382.811 284.154C384.182 284.024 385.565 284.05 386.936 284.05C399.806 284.05 412.664 284.05 425.534 284.05C426.866 284.05 428.123 284.257 429.075 285.307C430.243 286.589 430.534 288.079 429.9 289.699C429.227 291.409 427.894 292.226 426.13 292.238C422.132 292.264 418.147 292.251 414.149 292.251C411.014 292.251 407.891 292.251 404.756 292.251Z",
    fill: "url(#paint9_linear_147_11517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_11517",
    x1: 157.018,
    y1: 187.536,
    x2: 23.5582,
    y2: 314.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#00B7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00AFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00998F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_11517",
    x1: 26.5398,
    y1: 247.188,
    x2: 167.096,
    y2: 247.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#04ADAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#03A5A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#019289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_147_11517",
    x1: 69.4783,
    y1: 321.831,
    x2: 167.422,
    y2: 225.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#04ADAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#0CAFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#24B7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4AC3C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7FD5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C2EBEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_147_11517",
    x1: 25.0928,
    y1: 224.242,
    x2: 152.55,
    y2: 224.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#007E89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#007780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#006468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#004542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_147_11517",
    x1: 317.673,
    y1: 293.638,
    x2: 471.874,
    y2: 293.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDC249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F8BB40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EDAA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59C16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_147_11517",
    x1: 338.54,
    y1: 247.188,
    x2: 479.096,
    y2: 247.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFCD32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FAC42D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EDAC1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E59C16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_147_11517",
    x1: 381.478,
    y1: 321.831,
    x2: 479.422,
    y2: 225.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFDE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFDF2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFE246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FFE86C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFF0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FFFAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_147_11517",
    x1: 337.093,
    y1: 224.242,
    x2: 464.55,
    y2: 224.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#F0A617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DA8517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36217"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_147_11517",
    x1: 379.422,
    y1: 238.987,
    x2: 438.226,
    y2: 238.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_147_11517",
    x1: 379.397,
    y1: 288.144,
    x2: 430.23,
    y2: 288.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConvert);
export default __webpack_public_path__ + "static/media/iconConvert.5fa93703b406165f9760e556d0e58f5b.svg";
export { ForwardRef as ReactComponent };